import { Navigate } from "react-router-dom";
const PermissionGuard = ({ permissionKey, children }) => {
  const canAccess = localStorage.getItem(permissionKey) === "1" || localStorage.getItem("user_role") === "merchant";
  if (!canAccess) {
    return <Navigate to="/admin/forbidden" replace />;
  }
  return children;
};
export default PermissionGuard;
